import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";
import {
  CurrentTouchpointProvider,
} from "hooks/api/use-current-touchpoint";
import { useTouchpoint } from "hooks/api/use-touchpoints";
import { mapTouchpointDetail } from "utilities/api-mappers";

import { Route } from "utilities/app-routes";

const TouchpointProvider = ({
  children,
  currentTouchpointId,
  currentCampaignId,
}: React.PropsWithChildren<{ currentTouchpointId?: string; currentCampaignId?: string }>) => {
  const client = useCurrentClient();
  const { touchpointId } = useParams<{ touchpointId: string }>();
  const navigate = useNavigate();
  const campaign = useCurrentCampaign();

  const currTouchpointId = touchpointId || currentTouchpointId;
  const campaignId = currentCampaignId || campaign.id;
  const { data: touchpoint, isError } = useTouchpoint(
    currTouchpointId ?? "",
    {
      enabled: !!currTouchpointId,
    },
    {
      clientId: client.id,
      campaignId,
    },
  );

  useEffect(() => {
    if (isError) {
      navigate(Route.notFound);
    }
  }, [isError, navigate]);

  if (!touchpoint || touchpoint.id !== currTouchpointId) {
    return null;
  }

  return <CurrentTouchpointProvider touchpoint={touchpoint}>{children}</CurrentTouchpointProvider>;
};

export default TouchpointProvider;
